import _eol from "eol";
const eol = _eol;
/* Takes plaintext with no formatting */
export default (function getShortestLine(text) {
  return eol.split(text).sort((lineA, lineB) => {
    return lineA.length - lineB.length;
  })[0];
});